/* eslint-disable import/prefer-default-export */
export function toSnakeCase(key) {
  return key.replace(/([A-Z])/g, " $1").split(" ").join("_").toLowerCase();
}
